export default __webpack_public_path__ + "static/media/Games-Room.d956a8a2.webp";